import { getHomeLoanTotalLoanAmount } from '__core/shared/util/salestrekker';

import template from './compareLoanProducts.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    lenders: '<',
    documents: '<',
    compareProducts: '<',
    reviewProducts: '<',
    ticketOwner: '<',
    validationErrors: '<',
    isQuickTool: '<',
    isTicketSettled: '<',
    onUpdate: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdUtil, $mdMedia, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.chart = {
        isReady: false,
        data: []
      };
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.lenders = ctrl.lenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.reviewProducts = ctrl.reviewProducts || [];
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.isQuickTool = ctrl.isQuickTool || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        if (!ctrl.reviewProducts?.length && ctrl.compareProducts?.length) {
          ctrl.compareProducts = [];
          ctrl.saveCompareLoanProducts();
        }
        ctrl.setChartOfCompareLoanProducts();
        ctrl.setCommissionsPayable();
        ctrl.isReady = true;
      };

      ctrl.setChartOfCompareLoanProducts = () => {
        ctrl.chart.isReady = false;
        $timeout(() => {
          ctrl.chart = helperService.setChartOfCompareLoanProducts({
            compareProducts: ctrl.compareProducts
          });
        });
      };

      ctrl.setCommissionsPayable = () => {
        if (ctrl.organizationCountry?.cca2 !== 'NZ') {
          const len = ctrl.compareProducts?.length || 0;
          for (let c = 0; c < len; c += 1) {
            const compareProduct = ctrl.compareProducts[c];
            const lender = _.find(
              ctrl.ticketOwner?.lenderAccreditations || [],
              (l) => l?.idLender === compareProduct?.idLender
            );
            compareProduct.commissionsPayable.upfront = lender
              ? _.multiply(
                  _.divide(lender?.upfront || 0, 100),
                  compareProduct?.costs?.principal || 0
                )
              : 0;
            compareProduct.commissionsPayable.trail = lender
              ? _.divide(
                  _.multiply(
                    _.divide(lender?.trail || 0, 100),
                    compareProduct?.costs?.principal || 0
                  ),
                  12
                )
              : 0;
          }
          ctrl.saveCompareLoanProducts();
        }
      };

      ctrl.getTotalLoanAmountWithLmi = ({ id }) => {
        const idx = _.findIndex(ctrl.compareProducts || [], (c) => c?.id === id);
        return idx > -1
          ? ctrl.reviewProducts[idx]?.productSplits[0]?.totalLoanAmountWithLmi
          : 0;
      };

      ctrl.updateTicketValue = () => {
        const loanAmountWithLmi = getHomeLoanTotalLoanAmount(
          ctrl.reviewProducts,
          ctrl.organizationCountry.cca2
        );
        ctrl.onUpdate({ loanAmountWithLmi });
      };

      ctrl.toggleProductAsPreferred = (idx) => {
        ctrl.compareProducts[idx].isPreferred = !ctrl.compareProducts[idx].isPreferred;
        ctrl.reviewProducts[idx].isPreferred = !ctrl.reviewProducts[idx].isPreferred;
        ctrl.updateTicketValue();
        ctrl.setChartOfCompareLoanProducts();
        ctrl.saveCompareLoanProducts();
      };

      ctrl.isAnyOfProductsSetAsPreferred = () =>
        _.some(ctrl.compareProducts, (p) => p.isPreferred);

      ctrl.getApplicationPickUpTime = (idLender) => {
        const lender = ctrl.getLender(idLender);
        if (!lender?.turnaround) {
          return 'Application pick-up time: N/A';
        }
        return `Application pick-up time: ${
          parseInt(lender.turnaround, 10) === 1
            ? `${lender.turnaround} day`
            : `${lender.turnaround} days`
        }`;
      };

      ctrl.getLender = (idLender) => _.find(ctrl.lenders || [], (l) => l?.id === idLender);

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d?.lender[0]?.id === idLender && _.indexOf(d?.type, 'LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.getLoanTerm = (idx) => {
        const maxLoanTerm = _.maxBy(ctrl.compareProducts[idx]?.productSplits || [], 'loanTerm');
        return maxLoanTerm
          ? `${
              maxLoanTerm.loanTerm === 1
                ? `${maxLoanTerm.loanTerm} year`
                : `${maxLoanTerm.loanTerm} years`
            }`
          : '0 years';
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveCompareLoanProducts = _.debounce(() => {
        const data = {
          reviewProducts: ctrl.reviewProducts,
          compareProducts: ctrl.compareProducts
        };
        ctrl.onFinished({ data });
      }, 2000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
